import AHttpService from '@d-services/a-http-service/a-http-service';
import { addObjectToFormData } from '@d-shared/forms/forms';
import URLS from '@d-shared/urls/urls';

function getSearchParams(searchTerm, page, perPage) {
  const terms = [];

  if (searchTerm) {
    terms.push(`name=${ searchTerm }`);
  }

  if (page) {
    terms.push(`page=${ page }`);
  }

  if (perPage) {
    terms.push(`per_page=${ perPage }`);
  }

  if (!terms.length) {
    return '';
  }

  return `?${ terms.join('&') }`;
}

class FollowersService extends AHttpService {
  async getFollowers(userId, searchTerm = null, page = null, perPage = null) {
    let url = URLS.api.followers.followers.replace('<user-id>', userId);
    url = `${ url }${ getSearchParams(searchTerm, page, perPage) }`;

    const response = await this._http.get(url);
    return {
      meta: response.data.meta,
      usersList: response.data.followers,
    };
  }

  async getFollowersCount(userId) {
    const url = URLS.api.followers.followersCount.replace('<user-id>', userId);
    const response = await this._http.get(url);
    return response.data;
  }

  async getFollows(userId, searchTerm = null, page = null, perPage = null) {
    let url = URLS.api.followers.follows.replace('<user-id>', userId);
    url = `${ url }${ getSearchParams(searchTerm, page, perPage) }`;

    const response = await this._http.get(url);
    return {
      meta: response.data.meta,
      usersList: response.data.follows,
    };
  }

  async getFollowsCount(userId) {
    const url = URLS.api.followers.followsCount.replace('<user-id>', userId);
    const response = await this._http.get(url);
    return response.data;
  }

  async getSuggestions(searchTerm = null, page = null, perPage = null) {
    let url = searchTerm ?
      URLS.api.followers.followSuggestionsSearch :
      URLS.api.followers.followSuggestions;
    url = `${ url }${ getSearchParams(searchTerm, page, perPage) }`;
    const response = await this._http.get(url);
    return {
      meta: response.data.meta,
      usersList: response.data.follows,
    };
  }

  async followBulk(userIds) {
    const idsData = {
      ids: userIds,
    };
    const formData = new FormData();
    addObjectToFormData(idsData, formData);
    const response = await this._http.post(URLS.api.followers.followBulk, formData);
    return response.data;
  }

  async followUser(userId) {
    const url = URLS.api.followers.followUser.replace('<user-id>', userId);
    const response = await this._http.post(url, null);
    return response.data;
  }

  async stopFollowingUser(userId) {
    const url = URLS.api.followers.followUser.replace('<user-id>', userId);
    const response = await this._http.delete(url);
    return response.data;
  }
}

export default new FollowersService();
